import Component from "./component";

// The shared base for a "staged form" panel — one visible panel at a time, driven by a
// single `phase` value on the host's state machine. Extracted from three near-verbatim
// copies (the MemberOfferAcceptor's MoaPanel, the Rankometer's RankometerComponent, and
// the AccountPanel's AccountPanelComponent), each of which had grown its own identical
// constructor + renderPanelVisibility. Now they all inherit it here; the SuggestionPanel
// is the fourth host built directly on this base.
//
// It supplies exactly two things every stage-panel family shares:
//
//   1. The host's ONE state machine — taken FROM THE HOST, never a module singleton.
//      These components render inside surfaces that re-inject their markup (a modalbox, a
//      re-fetched pane), and a singleton would collect a subscriber per host and keep
//      every dead instance rendering. `host` is also stored so a panel can delegate
//      intents back to it (host.canResend(), etc.) — panels talk to the host, never
//      reach through it to its collaborators.
//   2. renderPanelVisibility() — the visibility preamble every panel's render() opens
//      with: show this panel iff the machine's phase is the one it is configured for.
//
// Deliberately NOT a template-method base: panels are SIBLINGS, not a hierarchy. Each
// owns its own elements, listeners, fields and render(), and CALLS renderPanelVisibility()
// itself rather than having a base render() orchestrate it. Anything richer than this
// plumbing (a `this.rankometer` alias, auth-status painting) stays on the per-family base
// that extends this one.
export default class StagePanel extends Component {

  constructor(id_or_element, host, config = {}) {
    super({
      element: id_or_element,
      config: config,
      stateMachine: host ? host.stateMachine : undefined,
    });
    this.host = host;
  }

  // Show this panel iff the machine's phase is the one it is configured for. Some panels
  // use the returned flag for what their visibility implies (a verify panel only ticks its
  // resend countdown while it is the panel showing).
  renderPanelVisibility() {
    const isActive = this.readStateMachineValue("phase") === this.config.phase;
    this.swapHtmlClassStates(isActive, "active", "inactive");
    return isActive;
  }

}
